import type { EmojiPackId } from './types';
import { normalizeCodepoints } from './placeholder';
import fluentui3d from './index_fluentui_3d.json';

export type EmojiPack = {
  id: EmojiPackId;
  label: string;
  tone?: 'color' | 'mono';
  resolveUrl: (codepoints: string) => string | null;
};

export type FluentUiStyle = '3d';
const fluentuiIndexByStyle: Record<FluentUiStyle, Record<string, string>> = {
  '3d': fluentui3d as Record<string, string>,
};

export const emojiConfig = {
  preferCdn: false,
  fluentuiStyle: '3d' as FluentUiStyle,
};

const fluentuiStyleDir: Record<FluentUiStyle, string> = {
  '3d': '3D',
};

export const emojiPacks: EmojiPack[] = [
  {
    id: 'fluentui',
    label: 'Fluent UI',
    tone: 'color',
    resolveUrl: (codepoints) => {
      const value = normalizeCodepoints(codepoints);
      const mapping = fluentuiIndexByStyle[emojiConfig.fluentuiStyle];
      const localPath = mapping[value];
      if (localPath) {
        return `/emoji/fluentui/${emojiConfig.fluentuiStyle}/${localPath}`;
      }
      if (emojiConfig.preferCdn) {
        if (!localPath) return null;
        const parts = localPath.split('/');
        const emojiName = parts[0];
        const fileName = parts.slice(1).join('/');
        const urlPath = [emojiName, fileName].map(encodeURIComponent).join('/');
        const styleDir = fluentuiStyleDir[emojiConfig.fluentuiStyle];
        const [encodedName, encodedFile] = urlPath.split('/');
        return `https://raw.githubusercontent.com/microsoft/fluentui-emoji/main/assets/${encodedName}/${styleDir}/${encodedFile}`;
      }
      return null;
    },
  },
];

export function getEmojiPack(packId: EmojiPackId) {
  return emojiPacks.find((pack) => pack.id === packId) ?? emojiPacks[0];
}
